<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6 md6 lg6>
                        <v-autocomplete
                          :items="riskAreaFilterList"
                          :label="labels.riskArea"
                          v-model="filters.riskArea"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('filters.riskArea')"
                          data-vv-name="filters.riskArea"
                          :data-vv-as="labels.riskArea"
                          v-validate="'entry'"
                          clearable
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="getHelpList('riskArea')" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-text-field
                          v-model="filters.riskAreaDesc"
                          :label="labels.riskAreaDesc"
                          :error-messages="errors.collect('filters.riskAreaDesc')"
                          data-vv-name="filters.riskAreaDesc"
                          :data-vv-as="labels.riskAreaDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-autocomplete
                          :items="riskAreaGLFilterList"
                          :label="labels.riskAreaGL"
                          v-model="filters.riskAreaGL"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('filters.riskAreaGL')"
                          data-vv-name="filters.riskAreaGL"
                          :data-vv-as="labels.riskAreaGL"
                          v-validate="'entry'"
                          clearable
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="getHelpList('riskAreaGLFilter')" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <!-- <v-card-text>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete :items="" :label="labels.col1Desc" v-model="form.col1Desc" item-text="label" item-value="value" data-vv-name="col1Desc" :data-vv-as="labels.col1Desc" :error-messages="errors.collect('col1Desc')" v-validate="'entry'" disabled></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="labels.ttyNo" v-model="form.ttyNo" item-text="label" item-value="value" data-vv-name="ttyNo" :data-vv-as="labels.ttyNo" :error-messages="errors.collect('ttyNo')" v-validate="'entry'" readonly></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text> -->
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title>
              <!-- Search table field -->
              <!-- <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field> -->
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                {{ labels.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="name"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td class="text-xs-left">{{ row.item.riskArea }}</td>
                      <td class="text-xs-left">{{ row.item.riskAreaDesc }}</td>
                      <td class="text-xs-left">{{ row.item.riskAreaGL }}</td>
                      <td class="text-xs-left">{{ row.item.debtTranBrn }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="showRiskArea" width="1000px">
      <v-card>
        <!-- <div slot="header">
          <v-icon>mdi-plus</v-icon>
          {{ newMode ? 'New Miscellaneous Treaty Information 1':'Edit Miscellaneous Treaty Information 1' }}
        </div> -->
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newMode">New Risk Area</v-toolbar-title>
          <v-toolbar-title v-else>Edit Risk Area</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <!-- <message :messages="messages"></message> -->
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :label="labels.riskArea"
                  v-model="form.riskArea"
                  item-text="label"
                  item-value="value"
                  data-vv-name="riskArea"
                  :data-vv-as="labels.riskArea"
                  :error-messages="errors.collect('riskArea')"
                  v-validate="'required'"
                  :disabled="this.newMode === false"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.riskAreaDesc"
                  v-model="form.riskAreaDesc"
                  item-text="label"
                  item-value="value"
                  data-vv-name="riskAreaDesc"
                  :data-vv-as="labels.riskAreaDesc"
                  :error-messages="errors.collect('riskAreaDesc')"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-autocomplete
                  :items="riskAreaGLFilterList"
                  :label="labels.riskAreaGL"
                  v-model="form.riskAreaGL"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('form.riskAreaGL')"
                  data-vv-name="form.riskAreaGL"
                  :data-vv-as="labels.riskAreaGL"
                  v-validate="'required'"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('riskAreaGL')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-autocomplete
                  :items="debtTranBrnFilterList"
                  :label="labels.debtTranBrn"
                  v-model="form.debtTranBrn"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('form.debtTranBrn')"
                  data-vv-name="form.debtTranBrn"
                  :data-vv-as="labels.debtTranBrn"
                  v-validate="'required'"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('debtTranBrn')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-checkbox
                  v-model="form.perInw"
                  :label="labels.perInw"
                  data-vv-name="perInw"
                  :data-vv-as="labels.perInw"
                  :error-messages="errors.collect('perInw')"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox
                  v-model="form.perOutw"
                  :label="labels.perOutw"
                  data-vv-name="perOutw"
                  :data-vv-as="labels.perOutw"
                  :error-messages="errors.collect('perOutw')"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex lg6 md6 xs12>
                <v-radio-group row v-model="form.permit" :mandatory="true" @change="doPermit($event)">
                  <v-radio :label="labels.perInw" value="perInw"></v-radio>
                  <v-radio :label="labels.perOutw" value="perOutw"></v-radio>
                </v-radio-group>
              </v-flex> -->
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ form.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doBack">Cancel</v-btn>
          <v-btn color="primary" text @click.native="doSave" :loading="submitting">Save</v-btn>
        </v-card-actions>
        <!-- <v-flex lg6 md12 xs12>
          <v-card-actions >
            <v-btn class="white--text error" @click.prevent="doBack">
              Cancel
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              Save
              <v-icon right>{{newMode? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-flex> -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="helplist" width="900px" persistent>
      <!-- Helplist component -->
      <riskArea-help-list v-if="riskAreaHelplist" @close="doClose" @selectRiskArea="doAssign($event)"></riskArea-help-list>
      <riskAreaGL-help-list v-if="riskAreaGLHelplist" @close="doClose" @selectRiskAreaGL="doAssign($event)"></riskAreaGL-help-list>
      <debtTranBrn-help-list v-if="debtTranBrnHelplist" @close="doClose" @selectBranch="doAssign($event)"></debtTranBrn-help-list>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete"> Are you sure to delete the selected RiskArea - {{ deleteRiskArea }} </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import RiskAreaHelplist from './helplist/RiskAreaHelplist.vue'
import RiskAreaGLHelplist from './helplist/RiskAreaGLHelplist.vue'
import DebtTranBrnHelplist from './helplist/DebtTranBrnHelplist.vue'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
// import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      newMode: false,
      reviewMode: false,
      loading: false,
      submitting: false,
      promptRemove: false,
      showRiskArea: false,
      helplist: false,
      filterHelplist: false,
      riskAreaHelplist: false,
      riskAreaGLHelplist: false,
      debtTranBrnHelplist: false,
      items: [],
      riskAreaFilterList: [],
      riskAreaGLFilterList: [],
      debtTranBrnFilterList: [],
      totalItems: 0,
      deleteRiskArea: '',
      selected: undefined,
      toggleArray: [false],
      labels: {
        newButton: 'New Risk Area',
        riskArea: 'Risk Area Code',
        riskAreaDesc: 'Risk Area Description',
        riskAreaGL: 'Risk Area GL',
        riskAreaGLDesc: 'Risk Area GL Description',
        debtTranBrn: 'Branch for Debtor Transaction',
        perInw: 'Permit Inwards',
        perOutw: 'Permit Outwards',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        date: 'date'
      },
      filters: {
        riskArea: null,
        riskAreaDesc: null,
        riskAreaGL: null
      },
      form: {
        riskArea: undefined,
        riskAreaDesc: undefined,
        riskAreaGL: undefined,
        debtTranBrn: undefined,
        permit: 'perInw',
        perInw: undefined,
        perOutw: undefined,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        date: new Date()
      },
      headers: [
        { text: 'Risk Area', value: 'riskArea' },
        { text: 'Risk Area Desciption', value: 'riskAreaDesc' },
        { text: 'Risk Area GL', value: 'riskAreaGL' },
        { text: 'Branch for Debtor Transaction', value: 'debtTranBrn' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.getRiskAreaFilterList('riskArea')
      this.getRiskAreaFilterList('riskAreaGL')
      this.getRiskAreaFilterList('debtTranBrn')
      this.fetchData() // List with filters
    },
    doClearFilters() {
      this.filters.riskArea = null
      this.filters.riskAreaDesc = null
      this.filters.riskAreaGL = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.fetchData(false)
    },
    doNew() {
      this.newMode = true
      this.showRiskArea = true
      this.form.riskArea = undefined
      this.form.riskAreaDesc = undefined
      this.form.riskAreaGL = undefined
      this.form.debtTranBrn = undefined
      this.form.perInw = true
      this.form.perOutw = false
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getRiskAreaPage
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((riskArea) => {
                const convertList = {
                  riskArea: riskArea.riskArea,
                  riskAreaDesc: riskArea.riskAreaDesc,
                  riskAreaGL: riskArea.riskAreaGL,
                  debtTranBrn: riskArea.debtTranBrn,
                  perInw: riskArea.perInw,
                  perOutw: riskArea.perOutw,
                  createdBy: riskArea.createdBy,
                  createdDate: riskArea.createdDate,
                  modifiedBy: riskArea.modifiedBy,
                  modifiedDate: riskArea.modifiedDate
                }
                this.items.push(convertList)
              })
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
    },
    doQuery(data) {
      this.newMode = false
    },
    doReview(data) {
      this.showRiskArea = true
      this.newMode = false
      this.form.riskArea = data.riskArea
      this.form.riskAreaDesc = data.riskAreaDesc
      this.form.riskAreaGL = data.riskAreaGL
      this.form.debtTranBrn = data.debtTranBrn
      this.form.perInw = data.perInw
      this.form.perOutw = data.perOutw
      this.form.createdBy = data.createdBy
      this.form.createdDate = data.createdDate
      this.form.modifiedBy = data.modifiedBy
      this.form.modifiedDate = data.modifiedDate
    },
    doDelete() {
      this.resetMessages()
      const apiURI = this.menu.deleteRiskArea
      if (apiURI) {
        const expand = this.selected
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selected = data
      this.promptRemove = true
      this.deleteRiskArea = data.riskArea
    },
    doBack() {
      this.showRiskArea = false
      this.newMode = true
      this.form.riskArea = undefined
      this.form.riskAreaDesc = undefined
      this.form.riskAreaGL = undefined
      this.form.debtTranBrn = undefined
      this.form.perInw = true
      this.form.perOutw = false
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.form.modifiedBy = undefined
      this.form.modifiedDate = undefined
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createRiskArea
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
          this.doInit()
          this.showRiskArea = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateRiskArea
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.doInit()
          this.showRiskArea = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'riskArea') {
        this.filterHelplist = true
        this.riskAreaHelplist = true
      } else if (fieldname === 'riskAreaGL') {
        this.filterHelplist = false
        this.riskAreaGLHelplist = true
      } else if (fieldname === 'riskAreaGLFilter') {
        this.filterHelplist = true
        this.riskAreaGLHelplist = true
      } else if (fieldname === 'debtTranBrn') {
        this.filterHelplist = false
        this.debtTranBrnHelplist = true
      }
    },
    doClose() {
      this.resetMessages()
      this.helplist = false
      setTimeout(() => {
        this.riskAreaHelplist = false
        this.riskAreaGLHelplist = false
        this.debtTranBrnHelplist = false
      }, 500)
    },
    doAssign(riskAreaObj) {
      if (riskAreaObj.riskAreaType === 'debtTranBrn') {
        this.form.debtTranBrn = riskAreaObj.branch
      } else if (riskAreaObj.riskAreaType === 'riskArea') {
        if (this.filterHelplist) {
          this.filters.riskArea = riskAreaObj.riskArea
        }
      } else if (riskAreaObj.riskAreaType === 'riskAreaGL') {
        if (this.filterHelplist) {
          this.filters.riskAreaGL = riskAreaObj.riskAreaGL
        } else {
          this.form.riskAreaGL = riskAreaObj.riskAreaGL
        }
      }
      this.filterHelplist = false
    },
    async getRiskAreaFilterList(param) {
      const apiURI = this.menu.getRiskAreaFilterList
      if (apiURI) {
        try {
          const params = {
            paramName: param
          }
          const result = await this.$http.get(expandURI(apiURI, params))
          if (result.data.dataList) {
            if (param === 'riskArea') {
              this.riskAreaFilterList = []
              if (result.data.dataList) {
                this.riskAreaFilterList = result.data.dataList
              }
            } else if (param === 'riskAreaGL') {
              this.riskAreaGLFilterList = []
              if (result.data.dataList) {
                this.riskAreaGLFilterList = result.data.dataList
              }
            } else if (param === 'debtTranBrn') {
              this.debtTranBrnFilterList = []
              if (result.data.dataList) {
                this.debtTranBrnFilterList = result.data.dataList
              }
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPermit(data) {
      if (data === 'perInw') {
        this.form.perInw = true
        this.form.perOutw = false
      } else if (data === 'perOutw') {
        this.form.perInw = false
        this.form.perOutw = true
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.riskArea.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    'riskArea-help-list': RiskAreaHelplist,
    'riskAreaGL-help-list': RiskAreaGLHelplist,
    'debtTranBrn-help-list': DebtTranBrnHelplist
  }
}
</script>
